import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core'
import { Category, File, Template } from 'depoto-core/src/entities'
import { CategoryTreeType } from '../../../models'
import { CoreService, HsApiService } from '../../../services'
import { ProductDetailService } from '../../../services/product-detail.service'
import * as Sentry from '@sentry/angular-ivy'
import { getThumbUrl as imageGetThumbUrl, SchemaUtil } from '../../../utils'
import { TranslateService } from '@ngx-translate/core'

@Component({
  selector: 'app-product-template-selection',
  templateUrl: './product-template-selection.component.html',
  styleUrls: ['./product-template-selection.component.scss'],
})
export class ProductTemplateSelectionComponent implements OnInit {
  @ViewChild('input') input: ElementRef
  selectedTemplate: Template
  categories: Category[]
  @Output() templateSelected: EventEmitter<any> = new EventEmitter<any>()
  public categoryTreeTypeEnum = CategoryTreeType
  public searchPhrase = ''
  public templates = []
  public isLoading = true
  public debounceTimer = null
  paginationDetail = ''
  filteredCategories = []

  @Input() isCreating: boolean
  @Input() loading: boolean

  constructor(
    private core: CoreService,
    private hsApi: HsApiService,
    private productDetailService: ProductDetailService,
    private translateService: TranslateService,
  ) {}

  async ngOnInit() {
    await this.getCategories()
    this.isLoading = false
  }

  async onFilterCategoriesChange(event) {
    this.filteredCategories = event
    await this.fetchTemplates()
  }

  async getCategories() {
    const hsRootCategory = await this.core.services.category.getList(
      {
        direction: 'ASC',
        filters: { hasParent: false, externalId: 'hs-root' },
      },
      SchemaUtil.category,
    )
    if (hsRootCategory?.items.length) {
      const result = await this.core.services.category.getList(
        {
          direction: 'ASC',
          filters: { hasParent: true, parent: hsRootCategory?.items[0]?.id },
        },
        SchemaUtil.category,
      )
      this.categories = result?.items || []
    }
  }

  async fetchTemplates() {
    this.isLoading = true
    try {
      const response = await this.hsApi.searchForHsTemplate(this.searchPhrase, this.filteredCategories)
      this.paginationDetail = this.translateService.instant('product.template.paginationDetail', {
        numberShown: `${response?.items?.length || 0}`,
        numberAll: `${response?.paginator?.totalCount || 0}`,
      })
      this.templates = response?.items || []
    } catch (err) {
      console.log(err)
    } finally {
      this.isLoading = false
    }
  }

  debounce(func, timeout = 300) {
    return (...args) => {
      clearTimeout(this.debounceTimer)
      this.debounceTimer = setTimeout(() => {
        func.apply(this, args)
      }, timeout)
    }
  }

  async selectTemplate(template) {
    this.productDetailService.loading = true
    if (this.selectedTemplate?.id === template.id) {
      this.selectedTemplate = null
    } else {
      this.selectedTemplate = template
    }
    this.templateSelected.emit(this.selectedTemplate)
  }

  public async templateSearchChange() {
    this.debounce(() => this.fetchTemplates(), 500)()
  }

  getThumbUrl(image: File, format: 'w135wp' | 'w2048wp' = 'w135wp'): string {
    return imageGetThumbUrl(image, format)
  }
}
